import window from "common/objects/window";

function stripFormatting(e) {
    //This looks weird because it is being incredibly pessimistic about the existence of clipboardData and getSelection.
    //This entire interface has broad browser support, but its all still technically experimental and could disappear.
    const plain = window.document.getSelection?.call(window.document).toString().trim();
    e.clipboardData?.clearData?.call(e.clipboardData, "text/html");
    e.clipboardData?.setData?.call(e.clipboardData, "text/plain", plain);
    e.preventDefault();
}

/**
 * This class can intercept copy/cut operations on an element and ensure that no formatting is carried along.
 */
export default class PlainTextCopy {

    constructor(element) {
        this.element = element;
        this.element.addEventListener("copy", stripFormatting);
    }

    destroy() {
        if(this.element) {
            this.element.removeEventListener("copy", stripFormatting);
            delete this.element;
        }
    }
}
